"use client";

import clsx from "clsx";

interface SuggestionCardProps {
  suggestion: string;
  onClick: (suggestion: string) => void;
  className?: string;
  disabled?: boolean;
}

const SuggestionCard: React.FC<SuggestionCardProps> = ({
  suggestion,
  onClick,
  className,
  disabled = false,
}) => {
  return (
    <button
      onClick={() => !disabled && onClick(suggestion)}
      className={clsx(
        "px-4 py-2 bg-background backdrop-blur-sm rounded-lg transition-all duration-200 border border-neutral text-700",
        "hover:bg-100 hover:shadow-sm hover:text-1000",
        "focus:outline-none focus:ring-2 focus:ring-gail-primary",
        disabled &&
          "opacity-50 cursor-not-allowed hover:bg-200/50 hover:shadow-none hover:border-transparent",
        className
      )}
      disabled={disabled}
    >
      {suggestion}
    </button>
  );
};

export default SuggestionCard;
